import React, { createContext, useContext, useState, useEffect } from 'react';
import { authApi } from '../utils/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [token, setToken] = useState(null);
  const [loading, setLoading] = useState(true);

  // On mount, check if we have a stored token and validate it
  useEffect(() => {
    const storedToken = localStorage.getItem('derbyscores_token');
    const storedUser = localStorage.getItem('derbyscores_user');

    if (storedToken && storedUser) {
      setToken(storedToken);
      try {
        setUser(JSON.parse(storedUser));
      } catch (e) {
        // Invalid stored user, clear it
        logout();
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password) => {
    const { data } = await authApi.login({ email, password });
    setToken(data.data.token);
    setUser(data.data.user);
    localStorage.setItem('derbyscores_token', data.data.token);
    localStorage.setItem('derbyscores_user', JSON.stringify(data.data.user));
    return data.data.user;
  };

  const register = async (formData) => {
    const { data } = await authApi.register(formData);
    setToken(data.data.token);
    setUser(data.data.user);
    localStorage.setItem('derbyscores_token', data.data.token);
    localStorage.setItem('derbyscores_user', JSON.stringify(data.data.user));
    return data.data.user;
  };

  const logout = () => {
    setUser(null);
    setToken(null);
    localStorage.removeItem('derbyscores_token');
    localStorage.removeItem('derbyscores_user');
  };

  const refreshUser = async () => {
    try {
      const { data } = await authApi.getMe();
      setUser(data.data);
      localStorage.setItem('derbyscores_user', JSON.stringify(data.data));
    } catch (err) {
      logout();
    }
  };

  const isAdmin = user?.role === 'master_admin';
  const isOrganizer = user?.role === 'organizer';
  const isParticipant = user?.role === 'participant';

  return (
    <AuthContext.Provider value={{
      user, token, loading,
      login, register, logout, refreshUser,
      isAdmin, isOrganizer, isParticipant,
      isAuthenticated: !!user
    }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const context = useContext(AuthContext);
  if (!context) throw new Error('useAuth must be used within AuthProvider');
  return context;
}
